// src/pages/CheckoutSuccess.jsx
import { useEffect, useState } from "react";
import { Container, Spinner, Alert, Button } from "react-bootstrap";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { api } from "../services/api";

export default function CheckoutSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  const { isAuthenticated, token } = useAuth();
  const navigate = useNavigate();

  const [status, setStatus] = useState("loading"); // "loading" | "ok" | "error"
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      if (!sessionId) {
        setStatus("error");
        setError("Missing session_id in URL.");
        return;
      }
      if (!isAuthenticated) {
        setStatus("error");
        setError("You must be logged in to complete the purchase.");
        return;
      }

      try {
        await api("/api/checkout/confirm", {
          method: "POST",
          token,
          body: { sessionId },
        });
        setStatus("ok");
      } catch (err) {
        console.error("Checkout confirm error:", err);
        setStatus("error");
        setError(err.message || "Unable to confirm payment.");
      }
    })();
  }, [sessionId, isAuthenticated, token]);

  return (
    <main className="py-5">
      <Container className="py-5">
        {status === "loading" && (
          <div className="text-center">
            <Spinner animation="border" />
            <p className="mt-3">Confirming your payment…</p>
          </div>
        )}

        {status === "ok" && (
          <div className="text-center">
            <h1 className="mb-3">Payment completed ✅</h1>
            <p>
              Your workout has been added to your profile. You can download the
              PDF from the <strong>My Workouts</strong> section.
            </p>
            <div className="d-flex justify-content-center gap-3 mt-4">
              <Button as={Link} to="/profile" variant="primary">
                Go to My Profile
              </Button>
              <Button as={Link} to="/workouts" variant="outline-secondary">
                Back to Workouts
              </Button>
            </div>
          </div>
        )}

        {status === "error" && (
          <div className="text-center">
            <Alert variant="danger">
              <p className="mb-1 fw-bold">Something went wrong.</p>
              <p className="mb-0">{error}</p>
            </Alert>
            <div className="d-flex justify-content-center gap-3 mt-3">
              <Button as={Link} to="/workouts" variant="secondary">
                Back to Workouts
              </Button>
              <Button onClick={() => navigate("/profile")} variant="outline-secondary">
                Go to My Profile
              </Button>
            </div>
          </div>
        )}
      </Container>
    </main>
  );
}
